import { ClaimFile } from "@amzn/ttechclaimintakeservice-client";
import { FileOption } from "./types";

export const convertClaimFilesResponseToOptions = (claimFilesList: ClaimFile[]) => {
  return (
    claimFilesList.reduce((result: FileOption[], file: ClaimFile) => {
      const tokenizedFileName = file?.fileName?.split("/") ?? [];
      const standaloneFileName = tokenizedFileName[tokenizedFileName?.length - 1];
      if (!standaloneFileName || !file.fileName) return result;
      result.push({
        value: file.fileName,
        label: standaloneFileName,
        lastUploadTimestamp: file.lastUploadTimestamp,
      });
      return result;
    }, []) ?? []
  );
};

export const AUTHORIZATION_FORM_DOWNLOAD_BTN_TEST_ID_PREFIX = "authorization-form-download-btn-";

// Cypress selects these buttons by prefix, so the id must not depend on any
// particular TPA appearing in the file name.
export const getAuthorizationFormDownloadTestId = (fileName: string): string => {
  const slug = fileName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return `${AUTHORIZATION_FORM_DOWNLOAD_BTN_TEST_ID_PREFIX}${slug}`;
};
